import { useMemo } from "react";
import { useAuth } from "@/context/AuthContext";
import { useWorkspace } from "@/context/WorkspaceContext";
import { Workspace, WorkspaceRole } from "@/types/workspace";

interface UseWorkspaceRoleResult {
  isMember: boolean;
  isWorkspaceOwner: boolean;
  isBillingAccountOwner: boolean;
  ownerWorkspaces: Workspace[];
}

export const useWorkspaceRole = (): UseWorkspaceRoleResult => {
  const { user } = useAuth();
  const { activeWorkspace, billingAccount, workspaces } = useWorkspace();

  return useMemo(() => {
    const workspaceRole = activeWorkspace?.role;
    const isMember =
      workspaceRole === WorkspaceRole.Member ||
      workspaceRole === WorkspaceRole.Admin ||
      workspaceRole === WorkspaceRole.Owner;
    const isWorkspaceOwner = workspaceRole === WorkspaceRole.Owner;
    const isBillingAccountOwner =
      !!user?.id && !!billingAccount?.owner_id && user.id === billingAccount.owner_id;

    const ownerWorkspaces = workspaces.filter(
      (workspace) => workspace.role === WorkspaceRole.Owner,
    );

    return {
      isMember,
      isWorkspaceOwner,
      isBillingAccountOwner,
      ownerWorkspaces,
    };
  }, [activeWorkspace?.role, billingAccount?.owner_id, user?.id, workspaces]);
};
